import { createSlice } from '@reduxjs/toolkit'

const customerStepsSlice = createSlice({
  name: 'customerStepsSlice',
  initialState: {
    currentTab: 1
  },
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload
    },
    resetCustomerSteps: state => {
      state.currentTab = 1
    }
  }
})

export const { setCurrentTab, resetCustomerSteps } = customerStepsSlice.actions
export default customerStepsSlice.reducer
